export default "__VITE_ASSET__ufAjZzPv__"